import "@/App.css";
import "@/index.css";
import { Routes, Route, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

// Components
import ScrollToTop from "@/components/ui/ScrollToTop";

// Chatbot
import SquareTriggerChatbot from "@/chatbot/SquareTriggerChatbot";

// Pages
import HomePage from "@/pages/HomePage";
import BlogPage from "@/pages/BlogPage";
import ContactPage from "@/pages/ContactPage";
import GetStartedPage from "@/pages/GetStartedPage";
import SolutionsPage from "@/pages/SolutionsPage";
import RdspToolForFinancialAdvisorsPage from "@/pages/RdspToolForFinancialAdvisorsPage";
import CustomDashboardDevelopmentVancouverPage from "@/pages/CustomDashboardDevelopmentVancouverPage";

import BurnabyDigitalAgencyPage from "@/pages/locations/BurnabyDigitalAgencyPage";
import SurreyDigitalAgencyPage from "@/pages/locations/SurreyDigitalAgencyPage";
import RichmondDigitalAgencyPage from "@/pages/locations/RichmondDigitalAgencyPage";
import NorthVancouverDigitalAgencyPage from "@/pages/locations/NorthVancouverDigitalAgencyPage";
import CoquitlamDigitalAgencyPage from "@/pages/locations/CoquitlamDigitalAgencyPage";
import LangleyDigitalAgencyPage from "@/pages/locations/LangleyDigitalAgencyPage";

// Service Pages
import WebsiteDevelopmentPage from "@/pages/services/WebsiteDevelopmentPage";
import ServicePage from "@/pages/services/ServicePage";
import SeoServicesPage from "@/pages/services/SeoServicesPage";
import SocialMediaMarketingPage from "@/pages/services/SocialMediaMarketingPage";
// import UiUxDesignPage from "@/pages/services/UiUxDesignPage";
import MaintenanceSupportPage from "@/pages/services/MaintenanceSupportPage";
// import EcommerceSolutionsPage from "@/pages/services/EcommerceSolutionsPage";

// Portfolio Pages
import CaseStudiesPage from "@/pages/portfolio/CaseStudiesPage";
import GalleryPage from "@/pages/portfolio/GalleryPage";
import TestimonialsPage from "@/pages/portfolio/TestimonialsPage";
import WorkPage from "@/pages/portfolio/WorkPage";

// Company Pages
import AboutPage from "@/pages/company/AboutPage";
import ProcessPage from "@/pages/company/ProcessPage";
import ValuesPage from "@/pages/company/ValuesPage";
import CareersPage from "@/pages/company/CareersPage";

// Resources Pages
import FAQsPage from "@/pages/resources/FAQsPage";
import FreeResourcesPage from "@/pages/resources/FreeResourcesPage";
import NewsPage from "@/pages/resources/NewsPage";

function App() {
  const location = useLocation();

  const noIndexRoutes = [];

  const shouldNoIndex = noIndexRoutes.some(
    (p) => location.pathname === p || location.pathname === `${p}/`
  );

  return (
    <>
      {/* Global Robots Tag */}
      <Helmet>
        <meta
          name="robots"
          content={shouldNoIndex ? "noindex, nofollow" : "index, follow"}
        />
      </Helmet>

      <ScrollToTop />

      <Routes>
        {/* Main Pages */}
        <Route path="/" element={<HomePage />} />

        {/* Blog  */}
        <Route path="/blogs" element={<BlogPage />} />
        <Route path="/blogs/:id" element={<BlogPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:id" element={<BlogPage />} />

        <Route path="/contact" element={<ContactPage />} />
        <Route path="/get-started" element={<GetStartedPage />} />
        <Route path="/solutions" element={<SolutionsPage />} />
        <Route path="/services" element={<SolutionsPage />} />
        <Route
  path="/rdsp-tool-for-financial-advisors"
  element={<RdspToolForFinancialAdvisorsPage />}
/>
<Route
  path="/custom-dashboard-development-vancouver"
  element={<CustomDashboardDevelopmentVancouverPage />}
/>

        {/* Local Pages  */}
        <Route path="/digital-agency-surrey" element={<SurreyDigitalAgencyPage />} />
        <Route path="/digital-agency-burnaby" element={<BurnabyDigitalAgencyPage />} />
        <Route path="/digital-agency-richmond" element={<RichmondDigitalAgencyPage />} />
        <Route
          path="/digital-agency-north-vancouver"
          element={<NorthVancouverDigitalAgencyPage />}
        />
        <Route path="/digital-agency-coquitlam" element={<CoquitlamDigitalAgencyPage />} />
        <Route path="/digital-agency-langley" element={<LangleyDigitalAgencyPage />} />

        {/* Local Pages  */}
        <Route path="/digital-marketing-agency-surrey" element={<SurreyDigitalAgencyPage />} />
        <Route path="/digital-marketing-agency-burnaby" element={<BurnabyDigitalAgencyPage />} />
        <Route path="/digital-marketing-agency-richmond" element={<RichmondDigitalAgencyPage />} />
        <Route
          path="/top-digital-agency-in-north-vancouver"
          element={<NorthVancouverDigitalAgencyPage />}
        />
        <Route path="/digital-marketing-agency-coquitlam" element={<CoquitlamDigitalAgencyPage />} />
        <Route path="/digital-marketing-agency-langley" element={<LangleyDigitalAgencyPage />} />

        {/* Service Pages */}
        <Route
          path="/services/website-development"
          element={<WebsiteDevelopmentPage />}
        />
        <Route path="/services/seo-services" element={<SeoServicesPage />} />
        <Route
          path="/services/social-media-marketing"
          element={<SocialMediaMarketingPage />}
        />
        <Route
          path="/services/maintenance-support"
          element={<MaintenanceSupportPage />}
        />

       
        <Route path="/services/:serviceSlug" element={<ServicePage />} />

        {/* Portfolio Pages */}
        <Route path="/portfolio/case-studies" element={<CaseStudiesPage />} />
        <Route path="/portfolio/gallery" element={<GalleryPage />} />
        <Route path="/portfolio/testimonials" element={<TestimonialsPage />} />
        <Route path="/work" element={<WorkPage />} />

        {/* Company Pages */}
        <Route path="/about" element={<AboutPage />} />
        <Route path="/company/about" element={<AboutPage />} />
        <Route path="/company/process" element={<ProcessPage />} />
        <Route path="/company/values" element={<ValuesPage />} />
        <Route path="/company/careers" element={<CareersPage />} />

        {/* Resources Pages */}
        <Route path="/faqs" element={<FAQsPage />} />
        <Route path="/resources-faqs" element={<FAQsPage />} />
        <Route path="/resources/faqs" element={<FAQsPage />} />
        <Route path="/resources/free" element={<FreeResourcesPage />} />
        <Route path="/resources/news" element={<NewsPage />} />

        {/* Fallback */}
        <Route path="*" element={<HomePage />} />
      </Routes>

      {/* Chatbot overlay on all pages */}
      {/* <SquareTriggerChatbot /> */}
    </>
  );
}

export default App;